const PropertyValue = ({ value, render }) => {
  if (!value && value !== 0 && value !== false && value !== '') return null
  return render ? render(JSON.stringify(value)) : JSON.stringify(value)
}

export default PropertyValue
